import React from 'react'
import Card from '../nura/card/card'
import Modal from '../modal/modal'
import Button from '../nura/button/button'
import BaseForm from "../base-form/base-form"

import styles from './styles.module.css'
import NodeInfo from '../node-info/node-info'

export default ({ show, onClose, data }) => {
    return (
        <Modal show={show} onClose={onClose}>
            <Card variant="modal" style={{ width: 358 }}>
                <BaseForm onBack={onClose} title={data?.name}>
                    <div style={{ paddingTop: 20}}>
                        <NodeInfo data={data} />
                    </div>
                    <div className={styles.actionGroup}>
                        <Button style={{ width: '100%' }} onClick={onClose} variant="outline">Ok</Button>
                    </div>
                </BaseForm>
            </Card>
        </Modal>
    )
}